// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"86d9872c068b3bad2c2f","122":"17ab5cbfd106cabeb71e","210":"24692cbad98354499ddf","356":"9c54acccabc75450fbcd","898":"5ab686d7596a3db710c8"}[chunkId] + ".chunk.js";
};